const CODE = /^[A-HJ-NP-Z2-9]{8}$/;
const FRIEND_PATH = /^\/friend\/([A-HJ-NP-Z2-9-]{8,12})\/?$/i;

export function normalizeFriendCode(value: string): string | null {
  const normalized = value.toUpperCase().replace(/[^A-Z2-9]/g, "");
  return CODE.test(normalized) ? normalized : null;
}

export function displayFriendCode(value: string): string {
  const normalized = normalizeFriendCode(value) ?? value.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
  return normalized.length === 8 ? `${normalized.slice(0, 4)}-${normalized.slice(4)}` : value;
}

export function friendCodeFromInvite(value: string, baseOrigin = "https://chess.akvastar.ru"): string | null {
  const clean = value.trim();
  const direct = normalizeFriendCode(clean);
  if (direct) return direct;

  try {
    const candidate = /^[a-z][a-z\d+.-]*:\/\//i.test(clean)
      ? clean
      : clean.startsWith("/")
        ? clean
        : `https://${clean}`;
    const url = new URL(candidate, baseOrigin);
    const pathCode = url.pathname.match(FRIEND_PATH)?.[1];
    if (pathCode) return normalizeFriendCode(pathCode);
  } catch {
    // Shared text can contain more than a URL, so try to find the displayed code below.
  }

  const embedded = clean.toUpperCase().match(/(?:^|[^A-Z2-9])([A-HJ-NP-Z2-9]{4})[-\s]?([A-HJ-NP-Z2-9]{4})(?:$|[^A-Z2-9])/);
  return embedded ? `${embedded[1]}${embedded[2]}` : null;
}
